import { createBrowserRouter, RouterProvider } from 'react-router';

import { useTenantSubscriptionConfig } from '@common/hooks';
import { TenantUtils } from '@utils/tenant';
import { useFeatureFlags } from '@common/hooks/useFeatureFlags';

import { createRouterConfig } from './config/routerConfig';

export function AppRouter(): JSX.Element {
    const { isTenantSubscriptionEnabled } = useTenantSubscriptionConfig();
    const { newOnboarding } = useFeatureFlags();

    const router = createBrowserRouter(createRouterConfig({ isTenantSubscriptionEnabled, newOnboarding }), {
        basename: TenantUtils.getURLPrefix(),
    });

    return <RouterProvider router={router} />;
}
